import React, { Component, ErrorInfo, ReactNode } from "react";
import {
  ErrorBoundaryWrapper,
  ErrorBoundaryText,
  ErrorBoundaryContent,
  ErrorBoundaryButtonWrapper,
} from "./index";

import { Button, ACEcolors } from "@ace/ace-ui-web";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  errorMessage: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }
  public static getDerivedStateFromError(error: any): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error: ", error, errorInfo);
    this.setState({ hasError: true, errorMessage: error.toString() });
  }

  navigateHandler = () => {
    //sending message to react native to navigate to home

    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({ navigateToHome: true })
    );
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryWrapper>
          <ErrorBoundaryContent>
            <ErrorBoundaryText>
              Sorry, there was an unexpected error. Please contact Ace Retailer
              Care Center.
            </ErrorBoundaryText>
            <ErrorBoundaryText>
              Error: {this?.state?.errorMessage}
            </ErrorBoundaryText>
            <ErrorBoundaryButtonWrapper>
              <Button
                colors={ACEcolors.primary}
                title={"Home"}
                onClick={this.navigateHandler}
              />
            </ErrorBoundaryButtonWrapper>
          </ErrorBoundaryContent>
        </ErrorBoundaryWrapper>
      );
    }
    return this.props.children;
  }
}
